import cn from 'classnames';
import React from 'react';
import Spinner from '@dealroadshow/uikit/core/components/Loader/Spinner';
import { dataTableStyles } from '@dealroadshow/uikit/core/components/Table/DataTable';

import tableWrapperStyles from './tableWrapper.scss';

interface IProps {
  children: React.ReactNode,
  className?: string,
  showSpinner: boolean,
}

const TableWrapper = ({
  children,
  className = '',
  showSpinner,
}: IProps) => (
  <div className={ tableWrapperStyles.tableWrapper }>
    <table
      className={ cn(dataTableStyles.dataTable, dataTableStyles.isHoverable, className) }
      data-test="fillingsTable"
    >
      { children }
    </table>
    { showSpinner && <Spinner overlay /> }
  </div>
);

export default TableWrapper;
